import { useLatestValue } from "@/src/lib/actions";

export const usePageSize = () => useLatestValue<number>("loc:page-size") ?? 10;
export const useSearch = () => useLatestValue<string>("loc:search") ?? "";
